module.exports = __webpack_public_path__ + "media/images/responsive/lp/online/icon_tel-d41761077e6c72cb65a75667ead330b4.svg";